import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-[#C5A059] mb-8">
            <ArrowLeft size={16} />
            Back to Home
          </Link>

          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-[#007AFF]/20 rounded-lg flex items-center justify-center">
              <Shield className="text-[#007AFF]" size={24} />
            </div>
            <h1 className="font-manrope font-bold text-3xl text-white">Privacy Policy</h1>
          </div>

          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg mb-8">
              Last updated: February 2026
            </p>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Introduction</h2>
              <p className="text-gray-300">
                Digital Gold Gang ("we," "our," or "us") respects your privacy and is committed to protecting 
                your personal data. This privacy policy explains how we collect, use, and safeguard your 
                information when you visit our website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Information We Collect</h2>
              <p className="text-gray-300 mb-4">We may collect the following types of information:</p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li><strong>Account Information:</strong> Email address, name, and profile picture when you sign in with Google</li>
                <li><strong>Usage Data:</strong> Information about how you interact with our website</li>
                <li><strong>Content:</strong> Posts, comments, and other content you create on our platform</li>
                <li><strong>Technical Data:</strong> IP address, browser type, and device information</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">How We Use Your Information</h2>
              <p className="text-gray-300 mb-4">We use your information to:</p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Provide and maintain our services</li>
                <li>Enable you to participate in community features</li>
                <li>Send you important updates about the platform</li>
                <li>Improve and personalize your experience</li>
                <li>Analyze usage patterns to enhance our content</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Data Security</h2>
              <p className="text-gray-300">
                We implement appropriate technical and organizational measures to protect your personal data. 
                However, no method of transmission over the Internet is 100% secure, and we cannot guarantee 
                absolute security.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Third-Party Services</h2>
              <p className="text-gray-300">
                Our website may contain links to third-party services and embedded content (such as TradingView 
                widgets). These third parties have their own privacy policies, and we encourage you to review them.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Cookies</h2>
              <p className="text-gray-300">
                We use cookies and similar technologies to enhance your experience, analyze traffic, and 
                personalize content. You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Your Rights</h2>
              <p className="text-gray-300 mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Contact Us</h2>
              <p className="text-gray-300">
                If you have questions about this privacy policy or your personal data, please contact us 
                through our community forum.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
